import { render } from "./VerticalNavMenuLink.vue?vue&type=template&id=58a72b9b"
import script from "./VerticalNavMenuLink.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenuLink.vue?vue&type=script&lang=js"
script.render = render

export default script